import { enableAnalytics, instanceInterceptors, POSTHOG_API_KEY, POSTHOG_HOST } from 'api';
import App from 'App';
import ErrorBoundaryComponent from 'components/ErrorBoundary/ErrorBoundaryComponent';
import { PostHogProvider } from 'posthog-js/react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import 'react-tooltip/dist/react-tooltip.css';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor, store } from 'redux/store';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <>
    <Provider store={store}>
      <ErrorBoundaryComponent>
        <PersistGate persistor={persistor}>
          <HelmetProvider>
            <PostHogProvider
              apiKey={POSTHOG_API_KEY}
              options={{
                api_host: POSTHOG_HOST,
                autocapture: false,
                capture_pageview: false,
                capture_pageleave: true,
                capture_dead_clicks: true,
                rageclick: true,
                disable_session_recording: !enableAnalytics,
                session_recording: {
                  sampleRate: 0.1,
                },
                loaded: (posthog) => {
                  if (!enableAnalytics) {
                    posthog.opt_out_capturing();
                  }
                  // fetch feature flags as early as possible on load
                  posthog.reloadFeatureFlags?.();
                },
              }}
            >
              <App />
            </PostHogProvider>
          </HelmetProvider>
        </PersistGate>
      </ErrorBoundaryComponent>
    </Provider>
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
instanceInterceptors(store);
